import { render, staticRenderFns } from "./TenantRenewalAmount.vue?vue&type=template&id=33ea71d0&"
import script from "./TenantRenewalAmount.vue?vue&type=script&lang=js&"
export * from "./TenantRenewalAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports